import { WireAddress } from 'scenes/common/api/quote/types';
import {
  toWireLockedBoxAddress,
  toWireMainAddress,
  toWirePostalAddress,
} from 'scenes/common/api/quote/marshaller/address';
import { HomeFunnelState } from 'scenes/home/types';
import {
  sameRiskAndPostalAddress,
  getLockedBoxAddress,
  getPostalAddress,
  getRiskAddress,
  isPostalAddressLockedBagGpo,
} from 'scenes/home/selectors';

export const toWireAddresses = (state: HomeFunnelState): WireAddress[] => {
  const addresses = [toWireMainAddress(getRiskAddress(state))];

  if (!sameRiskAndPostalAddress(state)) {
    addresses.push(
      isPostalAddressLockedBagGpo(state)
        ? toWireLockedBoxAddress(getLockedBoxAddress(state))
        : toWirePostalAddress(getPostalAddress(state))
    );
  }
  return addresses;
};
